import SettingService from './SettingsService';

export default SettingService;
